module.exports = __webpack_public_path__ + "img/gifting-online.53ec0e13.svg";